import {
  CategoryItem
} from "../../../../interfaces/Catalogue";
import "./OrderItem.scss";
import OrderItemContent from "./OrderItemContent/OrderItemContent";
import OrderItemHeader from "./OrderItemHeader/OrderItemHeader";

interface OrderItemProps {
  index: number;
  categoryItem: CategoryItem;
  orderType: number;
  canEditQuantity: boolean;
  canApplyArticleDiscount: boolean;
  rewardClaimDisabled?: boolean;

  restaurantId?: number;
  userLoyalityPoints?: number;
  totalLoyaltyPtsConsomed?: number;
}

const OrderItem = (props: OrderItemProps) => {
  const {
    restaurantId,
    index,
    categoryItem,
    orderType,
    canEditQuantity,
    canApplyArticleDiscount,
    rewardClaimDisabled,
    userLoyalityPoints,
    totalLoyaltyPtsConsomed,
  } = props;

  return (
    <div>
      <OrderItemHeader
        orderItemIndex={index}
        categoryItem={categoryItem}
        restaurantId={restaurantId}
        canApplyArticleDiscount={canApplyArticleDiscount}
        canEditQuantity={canEditQuantity}
        userLoyalityPoints={userLoyalityPoints}
        totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
        rewardClaimDisabled={rewardClaimDisabled}
      />
      <OrderItemContent
        orderItemIndex={index}
        categoryItem={categoryItem}
        mode={orderType}
        canApplyArticleDiscount={canApplyArticleDiscount}
        userLoyalityPoints={userLoyalityPoints}
        totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
        restaurantId={restaurantId || 0}
        rewardClaimDisabled={rewardClaimDisabled}
      />
    </div>
  );
};

export default OrderItem;
